<template>
  <el-dialog :title="title" :visible.sync="visible" :close-on-click-modal="false" @opened="openFun">
    <el-form :model="productDateForm" :rules="rules" ref="productDateRef" label-width="120px">
      <el-form-item v-show="false" prop="id">
        <el-input v-model="productDateForm.id"></el-input>
      </el-form-item>
      <el-form-item label="名称" prop="name">
        <el-input v-model="productDateForm.name" placeholder="请输入名称"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="resetForm('productDateRef')">重置</el-button>
      <el-button type="primary" :loading="isLoading" @click="submitForm('productDateRef')">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {savePlatform} from "@/api/prod/platform/platform";
import {successMsg} from "@/utils/message";
import {resetForm} from "@/utils/common";

export default {
  name: "editPlatform",
  props: {
    dialogVisible: {
      type: Boolean,
      require: true,
      default: false
    },
    productDateObj: Object
  },
  computed: {
    visible: {
      get: function () {
        return this.dialogVisible
      },
      set: function (val) {
        this.$emit('update:dialogVisible', val)
      }
    }
  },
  data(){
    return{
      title: '',
      isLoading: false,
      productDateForm: {
        id: null,
        name: '',
        value: null,
        status: '0'
      },
      rules: {
        name: [{required: true, message: '名称不能为空', trigger: 'blur'}],
        value: [{required: true, message: '周期不能为空', trigger: 'blur'}]
      }
    }
  },
  methods: {
    resetForm,
    openFun(){
      this.title = this.productDateObj.id ?"编辑" : "新增";
      if(Object.keys(this.productDateObj).length > 0){
        this.productDateForm = this.productDateObj
      }else{
        this.productDateForm = {
          id: null,
          name: '',
          value: null,
          status: '0'
        }
      }
    },
    //  提交
    submitForm(formName){
      this.$refs[formName].validate((valid) => {
        if (valid){
          this.isLoading = true
          savePlatform(this.productDateForm).then(() => {
            successMsg('操作成功')
            this.$emit('get-list')
          })
          this.isLoading = false
          this.visible = false
        }
      })
    }
  }
}
</script>

<style scoped>
 ::v-deep .vue-treeselect__control{
  height: 28px;
}
 ::v-deep .el-form-item__content{
   line-height: 28px;
   font-size: 12px;
 }
</style>